import React, {useEffect, useState} from "react";
import eye from './Assets/EyeHiddenPassword.svg';
import eyeSlash from './Assets/EyeSlash.svg';
import valid from'./Assets/Valid.svg';
import notValid from'./Assets/NotValid.svg';
const PasswordContainer=({userPassword, setUserPassword, passwordIsValid, setPasswordIsValid}: any)=>{
    const [showPassword, setShowPassword] = useState(false);
    const [passwordRequirements, setPasswordRequirements] = useState([
        { value: "8 Characters", enable: false },
        { value: "1 Uppercase letter", enable: false },
        { value: "Lowercase letter", enable: false },
        { value: "Special character", enable: false },
        { value: "Number", enable: false }
    ]);

    useEffect(() => {
        const requirements = [
            { value: "8 Characters", enable: userPassword.length >= 8 },
            { value: "1 Uppercase letter", enable: /[A-Z]/.test(userPassword) },
            { value: "Lowercase letter", enable: /[a-z]/.test(userPassword) },
            { value: "Special character", enable: /[!@#$%^&*(),.?":{}|<>]/.test(userPassword) },
            { value: "Number", enable: /\d/.test(userPassword) }
        ];
        setPasswordRequirements(requirements);
        const allRequirementsMet = requirements.every(req => req.enable);
        setPasswordIsValid(allRequirementsMet);
    }, [userPassword]);
    const togglePasswordVisibility = () => {
        setShowPassword(prev => !prev);
    };

    return(
        <div className="password-div">
            <label htmlFor="password" className="password-label">Password</label>
            <div className="input-group">
                <input
                    type={showPassword ? 'text' : 'password'}
                    id="password"
                    value={userPassword}
                    onChange={(e) => setUserPassword(e.target.value)}
                    placeholder="Enter your password"
                    className="custom-input password-container"
                />
                <button
                    type="button"
                    className="eyePassword"
                    onClick={togglePasswordVisibility}
                    aria-label={showPassword ? 'Hide password' : 'Show password'}
                >
                    {showPassword ? <img src={eyeSlash} alt="Entered Password" /> : <img src={eye} alt="Hidden Password"/>}
                </button>
            </div>

            <span className="requirements">
                Use at least:
                {passwordRequirements.map((req, index) => (
                    <span key={index} className="requirements">
                        {req.enable ? <img src={valid} alt="valid" /> : <img src={notValid} alt="not valid" />} {req.value}
                    </span>
                ))}
            </span>

        </div>
    );
}
export default PasswordContainer;